<itb-icon [tooltipText]="tooltipText" [className]="iconClassName"></itb-icon>
<itb-text [className]="'text-x-small'" [text]="text"></itb-text>
